import { Button, Card, Grid, TextField } from '@mui/material';
import { deleteObjectApi, getObjectListByPropertyApi, postSaveObjectApi, putUpdateObjectApi } from 'api/general';
import { controlOfAllUserInputs } from 'api/meeting';
import { chunkData, getSubjectName, highlightText, stripHTMLTags } from 'app/utils/appHelpers';
import { CRON_DATA, REVIEWS } from 'app/utils/constants/customConstant';
import { baseFontSize, dshCardHeight } from 'config';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showAgendaSnackbar } from 'stores/meeting';
import DshBoxTitle from '../Box/DshBoxTitle';
import ReviewFileListTable from '../Table/ReviewFileListTable';

function AddUpdateReviewCard({ decision, index, addAfterTable, updateAfterTable, handleDelete, setReviewInputStatus, reviewOfTheUser, highlightQuery, decisionFiles }) {

    const dispatch = useDispatch();
    const userList = useSelector(state => state.user.data || []);

    const { authUser } = useSelector(state => state.auth);
    const [buttonText, setButtonText] = useState(reviewOfTheUser?.id ? "Güncelle" : "Kaydet");
    const subjectList = useSelector(state => state.subject.data || []);
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [isDeleteButtonVisible, setIsDeleteButtonVisible] = useState(!!reviewOfTheUser?.id);

    const emptyReview = {
        userId: authUser.id,
        meetingId: currentMeeting.id,
        decisionId: decision.id,
        info: '',
        pdate: new Date()
    };
    const [review, setReview] = useState(reviewOfTheUser === undefined ? emptyReview : reviewOfTheUser);

    const filedata = (decisionFiles || []).filter(item => item.decisionId === decision.id);
    const agendaFileList = filedata.filter(item => item.fileInfo === null || item.fileInfo === "");
    agendaFileList.forEach(element => {
        element.user = userList.find(item => item.id === element.adminUserId);
    });
    const linkList = filedata.filter(item => item.fileInfo !== "" && item.ext === "");

    const buttonTextChange = async (type) => {
        if (type === 1) { // guncelleme
            setButtonText("Güncelle")
            setIsDeleteButtonVisible(true);

        } else if (type === 2) { // ekle
            setButtonText("Kaydet")
            setIsDeleteButtonVisible(false);
        }

    };


    const groupedData = chunkData(agendaFileList, 5);
    const groupedDataLink = chunkData(linkList, 5);

    const handleSave = async () => {

        // En az 3 karakter kontrolü
        if (!review.info || review.info.trim().length < 3) {
            dispatch(showAgendaSnackbar({ message: 'Değerlendirmeniz boş kaydedilemez.', severity: 'warning' }));
            return;
        }

        try {

            if (review.id) { // guncelleme
                let reviewWithoutUser = Object.assign({}, review);
                delete reviewWithoutUser.user;
                reviewWithoutUser.pdate = new Date(); // Add current timestamp
                review.pdate = new Date();
                const result = await putUpdateObjectApi(REVIEWS, reviewWithoutUser);
                if (result.status) {
                    window.getSelection?.()?.removeAllRanges?.();
                    dispatch(showAgendaSnackbar({ message: 'Görüşünüz güncellendi.', severity: 'success' }));
                    updateAfterTable && updateAfterTable({ ...review })

                }


            } else { // ekleme


                const result = await postSaveObjectApi(REVIEWS, review);
                if (result.status) {
                    window.getSelection?.()?.removeAllRanges?.();
                    dispatch(showAgendaSnackbar({ message: 'Görüşünüz kaydedildi.', severity: 'success' }));
                    review.id = result.data.insertId;
                    setButtonText("Güncelle")
                    setIsDeleteButtonVisible(true)
                    addAfterTable({ id: result.data.insertId, ...review }); // sor????
                }


            }

        } catch (error) {
            console.error('Hata:', error);
        }

        finally {


            if (review.id !== undefined) {
                const result = await controlOfAllUserInputs(review.meetingId, "review");
                if (result.status) {
                    if (result.data === 0) {



                        // hatırlatıcı varsa silme yapılıyor
                        let existingCron = await getObjectListByPropertyApi(CRON_DATA, "meetingId", review.meetingId);
                        existingCron = existingCron.data;
                        if (existingCron.length > 0) {
                            for (const item of existingCron) {
                                await deleteObjectApi(CRON_DATA, item.id);
                            }
                        }

                        dispatch(showAgendaSnackbar({ message: 'Bu toplantıya ait tüm değerlendirmeler tamamlandı.', severity: 'success' }));



                    }
                }
            }

        };

    };


    const handleDeleteItem = async (review) => {
        const result = await handleDelete(review)
        if (result.status) {
            window.getSelection?.()?.removeAllRanges?.();
            dispatch(showAgendaSnackbar({ message: 'Değerlendirmeniz silindi.', severity: 'success' }));
            setReview(emptyReview)
            setReviewInputStatus(false)

            await buttonTextChange(2)
        }
    };


    const handleChange = name => (e) => {

        setReview({
            ...review,
            [name]: e.target.value
        })
    }


    const secondTitle = review.id !== undefined
        ? "Değerlendirdiniz"
        : "Henüz Değerlendirmediniz";

    return (
        <>
            <div style={{ fontSize: baseFontSize }}>
                    <Card
                        key={index}
                        sx={{
                            m: 0,
                            p: '10px',
                            marginBottom: 0,
                            minHeight: `${dshCardHeight}`,
                            // height: `${dshPreviousCardHeight}`,
                        }}
                    >
                        <DshBoxTitle secondTitle={secondTitle} color="primary" title={`Gündem Maddesi ${decision.decisionNo}` + " / " + getSubjectName(decision.subjectId, subjectList)} />


                        <Grid container>
                            <Grid item xs={12} md={12} lg={12} sx={{ padding: 1, fontSize: baseFontSize }}>
                                <span style={{ whiteSpace: "pre-line" }}>{highlightText(stripHTMLTags(decision.agenda), highlightQuery)}</span>
                            </Grid>

                            <Grid
                                container
                                marginY={2}
                                marginX={0}
                                spacing={1}
                                rowSpacing={1}
                            >
                                <Grid item xs={11} md={11} lg={11}>
                                    <TextField
                                        variant="outlined"
                                        label="Gündem hakkındaki değerlendirmenizi yazınız..."
                                        multiline
                                        fullWidth
                                        rows={6}
                                        value={review.info}
                                        onChange={handleChange("info")}
                                        InputProps={{
                                            style: { fontSize: baseFontSize },
                                        }}
                                        InputLabelProps={{
                                            style: { fontSize: baseFontSize },
                                        }}
                                    />

                                </Grid>

                                <Grid item xs={6} md={6} lg={1}>
                                    <Button
                                        variant="contained"
                                        size='small'
                                        color="success"
                                        onMouseDown={(e) => e.preventDefault()}
                                        onClick={handleSave}
                                        style={{
                                            maxWidth: "100%",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {buttonText}
                                    </Button>
                                    {isDeleteButtonVisible && (
                                        <Button
                                            variant="contained"
                                            color="error"
                                            size='small'
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={() => handleDeleteItem(review)}
                                            style={{
                                                marginTop: "5px",
                                                maxWidth: "100%",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}
                                        >
                                            Sil
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={12} lg={12}>
                                <ReviewFileListTable groupedData={groupedData} borderType={false} />
                            </Grid>

                            {groupedDataLink.length > 0 && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <ReviewFileListTable groupedData={groupedDataLink} borderType={false} dataType='link' />
                                </Grid>
                            )}
                        </Grid>
                    </Card>
            </div>

        </>

    );
}
export default AddUpdateReviewCard;


